import { observer } from 'mobx-react-lite'
import { Alert, InputCheckbox } from 'shared/ui'
import { MultiSelectMembers } from 'widgets/MultiSelectMembers/MultiSelectMembers.tsx'
import { AgentSwitchField } from 'pages/chatbot/ui/AgentSwitchField/AgentSwitchField.tsx'
import { type HandoffNotifySettingsStore } from 'pages/chatbot/ui/ChatbotEdit/StepHandoff/ui/HandoffNotifySettings/store/HandoffNotifySettingsStore.ts'
import styles from './styles.module.scss'

export const HandoffNotifySettings = observer(
  ({ store }: { store: HandoffNotifySettingsStore }) => {
    const {
      isNotifyTeamMembers,
      setNotifyTeamMembers,
      notifyConversationAssignee,
      setNotifyConversationAssignee,
      notifyContactOwner,
      setNotifyContactOwner,
      notifyAllInboxMembers,
      setNotifyAllInboxMembers,
      notify_additional_users,
      set_notify_additional_users,
    } = store
    return (
      <>
        <Alert
          item={{
            type: 'infoBlue',
            desc: 'AI Agent summarizes the conversation and notifies team members with an internal note.',
          }}
        />
        <AgentSwitchField
          size={'medium'}
          active={isNotifyTeamMembers}
          onChange={setNotifyTeamMembers}
          title={'Notify team members'}
          description={'Selected members will get a mention'}
          content={
            isNotifyTeamMembers && (
              <div>
                <InputCheckbox
                  checked={notifyConversationAssignee}
                  onChecked={() => setNotifyConversationAssignee(!notifyConversationAssignee)}
                  label={'Conversations assignee'}
                />
                <InputCheckbox
                  checked={notifyContactOwner}
                  onChecked={() => setNotifyContactOwner(!notifyContactOwner)}
                  label={'Contact owner'}
                />
                <InputCheckbox
                  checked={notifyAllInboxMembers}
                  onChecked={() => setNotifyAllInboxMembers(!notifyAllInboxMembers)}
                  label={'All inbox members'}
                />
                <div className={styles.additionalMembers}>
                  <MultiSelectMembers
                    filterMembersDropdownItems={({ data }) => {
                      if (data) {
                        return !data.isViewOnlyRole
                      }
                      return false
                    }}
                    values={notify_additional_users}
                    setValues={set_notify_additional_users}
                    labelProps={{
                      label: {
                        text: 'Additional members',
                      },
                    }}
                  />
                </div>
              </div>
            )
          }
        />
      </>
    )
  }
)
